import React from 'react';
import './MenuCard.css';

const MenuCard = ({ 
  product, 
  onAddToCart,
  showBadge = false 
}) => {
  const handleAddToCart = () => {
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  return (
    <div className="menu-card">
      {showBadge && product.badge && (
        <div className="menu-card-badge">
          {product.badge}
        </div>
      )}
      
      <div className="menu-card-image-container">
        <div className="menu-card-image-bg"></div>
        <img 
          src={product.image} 
          alt={`${product.name} - ${product.description || 'WakaGyros görög specialitás'}`}
          className="menu-card-image"
          loading="lazy"
          decoding="async"
          fetchpriority="low"
        />
      </div>
      
      <div className="menu-card-content">
        <h3 className="menu-card-name">{product.name}</h3>
        <p className="menu-card-description">{product.description}</p>
        <div className="menu-card-price">{product.price}</div>
        <button 
          className="menu-card-cta"
          onClick={handleAddToCart}
          aria-label={`${product.name} hozzáadása a kosárhoz`}
        >
          Kosárba teszem
        </button>
      </div>
    </div>
  );
};

export default MenuCard;

